import React, { Component } from "react"
import Loadable from "@loadable/component"

const LoadableSupsim = Loadable(() => import("./Main"), {fallback: 'Loading Supsim...'})
export default LoadableSupsim
